"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryDateToAccountingDocIssuedateWithForecast = void 0;
const typeorm_1 = require("typeorm/browser");
let DeliveryDateToAccountingDocIssuedateWithForecast = class DeliveryDateToAccountingDocIssuedateWithForecast {
};
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'job_api_id' }),
    __metadata("design:type", String)
], DeliveryDateToAccountingDocIssuedateWithForecast.prototype, "jobApiId", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'delivered_to_invoiced_timerange' }),
    __metadata("design:type", Number)
], DeliveryDateToAccountingDocIssuedateWithForecast.prototype, "deliveredToInvoicedTimerange", void 0);
DeliveryDateToAccountingDocIssuedateWithForecast = __decorate([
    (0, typeorm_1.ViewEntity)({
        name: 'delivery_date_to_accounting_doc_issuedate_with_forecast',
        schema: 'analytics',
        materialized: true,
        expression: `
    SELECT
      AVG(delivered_to_invoiced_timerange) AS delivered_to_invoiced_timerange,
      job_api_id
    FROM
    (
      SELECT
        j.api_id__c AS job_api_id,
        CASE
          WHEN j.date_end__c IS NOT NULL AND doc.created_at IS NOT NULL THEN (doc.created_at - j.date_end__c)
          WHEN doc.created_at IS NULL OR j.date_end__c IS NULL
          THEN
            COALESCE(
              (
                SELECT AVG(docjd.created_at - jd.date_end__c)
                FROM
                  public.job__c jd
                  LEFT JOIN materialized_job_types mjdt ON mjdt.job_api_id = jd.api_id__c
                  LEFT JOIN accounting.accounting_document_to_jobs doctojobsd ON doctojobsd.job__c_sfid = jd.sfid
                  LEFT JOIN accounting.accounting_document docjd ON docjd.id = doctojobsd.accounting_document_id
                WHERE jd.opportunity__c = j.opportunity__c AND
                  JSON_BUILD_OBJECT(
                    'installation', mjt.installation,
                    'precheck', mjt.precheck,
                    'activation', mjt.activation,
                    'remote', mjt.remote,
                    'hardware_sale', mjt.hardware_sale,
                    'maintenance', mjt.maintenance,
                    'planning', mjt.planning,
                    'customer_sign_required', mjt.customer_sign_required,
                    'async_appointment', mjt.async_appointment,
                    'meter_application', mjt.meter_application,
                    'installation_preparation', mjt.installation_preparation,
                    'defect_elimination', mjt.defect_elimination
                  )::TEXT = JSON_BUILD_OBJECT(
                    'installation', mjdt.installation,
                    'precheck', mjdt.precheck,
                    'activation', mjdt.activation,
                    'remote', mjdt.remote,
                    'hardware_sale', mjdt.hardware_sale,
                    'maintenance', mjdt.maintenance,
                    'planning', mjdt.planning,
                    'customer_sign_required', mjdt.customer_sign_required,
                    'async_appointment', mjdt.async_appointment,
                    'meter_application', mjdt.meter_application,
                    'installation_preparation', mjdt.installation_preparation,
                    'defect_elimination', mjdt.defect_elimination
                  )::TEXT
                  AND docjd.created_at IS NOT NULL AND jd.date_end__c IS NOT NULL
                  AND jd.status__c NOT IN ('closed', 'cancelled')
                  AND jd.createddate >= NOW() - INTERVAL '1 year'
              ),
              (
                SELECT AVG(docjd.created_at - jd.date_end__c)
                FROM
                  public.job__c jd
                  LEFT JOIN materialized_job_types mjdt ON mjdt.job_api_id = jd.api_id__c
                  LEFT JOIN accounting.accounting_document_to_jobs doctojobsd ON doctojobsd.job__c_sfid = jd.sfid
                  LEFT JOIN accounting.accounting_document docjd ON docjd.id = doctojobsd.accounting_document_id
                WHERE jd.opportunity__c = j.opportunity__c
                  AND docjd.created_at IS NOT NULL
                  AND jd.date_end__c IS NOT NULL
                  AND jd.status__c NOT IN ('closed', 'cancelled')
                  AND jd.createddate >= NOW() - INTERVAL '1 year'
              ),
              (
                SELECT AVG(docjd.created_at - jd.date_end__c)
                FROM
                  public.job__c jd
                  LEFT JOIN materialized_job_types mjdt ON mjdt.job_api_id = jd.api_id__c
                  LEFT JOIN accounting.accounting_document_to_jobs doctojobsd ON doctojobsd.job__c_sfid = jd.sfid
                  LEFT JOIN accounting.accounting_document docjd ON docjd.id = doctojobsd.accounting_document_id
                WHERE docjd.created_at IS NOT NULL
                  AND jd.date_end__c IS NOT NULL
                  AND jd.status__c NOT IN ('closed', 'cancelled')
                  AND jd.createddate >= NOW() - INTERVAL '1 year'
              )
            )
        END AS delivered_to_invoiced_timerange
      FROM public.job__c j
      INNER JOIN materialized_job_types mjt ON mjt.job_api_id = j.api_id__c
      LEFT JOIN accounting.accounting_document_to_jobs doctojobs ON doctojobs.job__c_sfid = j.sfid
      LEFT JOIN accounting.accounting_document doc ON doc.id = doctojobs.accounting_document_id
    ) AS jobs_delivered_to_invoiced_ranges
    WHERE delivered_to_invoiced_timerange > INTERVAL '0 second'
    GROUP BY job_api_id
  `,
    })
], DeliveryDateToAccountingDocIssuedateWithForecast);
exports.DeliveryDateToAccountingDocIssuedateWithForecast = DeliveryDateToAccountingDocIssuedateWithForecast;
//# sourceMappingURL=materialized-delivery-date-to-accounting-doc-issuedate-wth-forecast.js.map